import { isTaskBreakdownSupported } from 'src/features/room/helpers/is-task-breakdown-supported';
export const useIsTaskBreakdownSupported = (roomCode: string) => isTaskBreakdownSupported(roomCode);